export default {
  banner: {
    title: "Join Authing to meet better you",
    subtitle:
      "Become a member of the world's leading team of computer science, identity security, data and business management experts",
  },
  work: {
    title: "Authing of team members",
    imgurl: "//files.authing.co/authing-website/joinus-common.png",
  },
  jobs: {
    title: "Our Position",
    subtitle:
      'Please send your resume to: lewisli@authing.cn, the subject of the email is "Recruitment-Position Name-Name"',
    tabs: {
      "tab-one": "All",
      "tab-two": "Engineer",
      "tab-three": "Business",
      "tab-four": "Other",
    },
    "button-apply": "apply",
    "job-one": {
      title: "Full stack development engineer",
      intro: `Participate in the design and implementation of the front-end and back-end infrastructure of the company's external products, and provide stable and reliable services...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Participate in the design and implementation of the front-end and back-end infrastructure of the company's external products, and provide stable and reliable services;",
        item1:
          "2. Responsible for the design and implementation of the front-end and back-end architecture of the internal platform;",
        item2:
          "3. Responsible for technical research and innovative technology reference, and solve the problems of high performance, high concurrency and high reliability in the product development process;",
        item3:
          "4. Responsible for the research and development of the company's cloud service products and developer platform;",
        item4:
          "5. Investigate the company's R&D system and process, and provide platform design and technical solutions for the corresponding underlying services;",
        item5:
          "6. Implement the design plan as a specific platform function, continue to track the results, and continuously optimize the user experience;",
        item6:
          "7. Participate in the design of platform data structure and system architecture, and realize some services in the platform through Node.js;",
        item7:
          "8. Responsible for the architecture design and implementation of the project delivered by the company's customers.",
      },
      skills: {
        item0: "1. More than 3 years of Internet development experience, in-depth understanding of Unix / Linux;",
        item1:
          "2. Excellent coding ability, proficient in Node.js, familiar with commonly used algorithms, familiar with open source framework, and strong problem-solving ability;",
        item2:
          "3. Familiar with front-end framework React/Vue, familiar with front-end engineering and component development mode;",
        item3: "4. Rich experience in performance optimization of back-end programs;",
        item4: "5. Master the principles and applications of storage systems such as Redis, MongoDB, and MySQL;",
        item5:
          "6. Have a certain understanding of distributed computing and distributed storage architecture design concepts and motivations;",
        item6:
          "7. Have a deep understanding of the HTTP protocol, and be familiar with network protocols such as TCP/IP;",
        item7:
          "8. Bonus points: Have experience in Python, Go, and PHP development; participate in or own open source projects, and have contributed code to the open source community; have experience in design and development of large-scale back-end services.",
      },
    },
    "job-two": {
      title: "Front-end development engineer",
      intro: `Participate in customer demand research, system design and architecture work for the company's mid-stage project...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Participate in customer demand research, system design and architecture work for the company's mid-stage project;",
        item1: "2. Complete the development, testing and deployment of various modules;",
        item2:
          "3. Develop high-quality upper-level applications that serve millions of users based on the company's products.",
      },
      skills: {
        item0: "1. Solid computer foundation, familiar with data structure, network, etc.;",
        item1: "2. Have in-depth research on at least one MV* framework (such as React or Vue, etc.);",
        item2:
          "3. Understand the back-end technology stack, be familiar with the back-end language Node.js, and be familiar with the collaboration mode with the back-end;",
        item3:
          "4. Have a certain understanding of user experience, interaction and user demand analysis, product or interface design experience is preferred;",
        item4:
          "5. Knowledge and practical experience in cloud computing, IDaaS or developer-related products are preferred, and those familiar with Serverless, FaaS, and DevOps related technologies are preferred;",
        item5:
          "6. Those who have high technical enthusiasm and enthusiasm, have good communication skills, can withstand strong work pressure, have teamwork spirit, can understand problems from the perspective of users, discover deficiencies, and are good at summarizing;",
        item6:
          "7. Bonus items: Participate in or lead excellent open source projects; have excellent technical blog posts and blogs.",
      },
    },
    "job-three": {
      title: "DevOps Development Engineer",
      intro: `Responsible for the construction and maintenance of the automated operation and maintenance platform and DevOps system...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "Responsible for the construction and maintenance of the automated operation and maintenance platform and DevOps system;",
        item1:
          "Responsible for R&D life cycle tools and systems, such as continuous integration, code release, capacity planning, monitoring, etc.",
      },
      skills: {
        item0: "1. Familiar with at least one development language and have complete project development experience;",
        item1:
          "2. Familiar with cloud native architecture, familiar with public cloud platforms such as AWS, Alibaba Cloud, and Tencent Cloud. Familiar with Terraform orchestration tools;",
        item2:
          "3. Familiar with Kubernetes technology and principles, and have in-depth Kubernetes practical experience;",
        item3:
          "4. Familiar with automated operation and maintenance management tools (Puppet / Saltstack / Ansible), hate manual operation;",
        item4:
          "5. Familiar with log processing and analysis related experience, familiar with related components, such as: Kafka, ELK, Flume, Hive, Storm, etc.",
        item5: "6. Have experience in continuous integration, continuous delivery and automated release;",
        item6: "7. Strong learning ability, active work, diligent, conscientious, and service-conscious;",
        item7:
          "8. Bonus items: Participated in the establishment of a complete operation and maintenance system; have the following relevant experience: asset management platform, service quality monitoring, SLA management.",
      },
    },
    "job-four": {
      title: "Mobile development engineer Android / iOS",
      intro:
        "Responsible for the module program for the Android / iOS platform, packaged into SDK under each hybrid development framework, adaptation and testing, and technical support...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "Responsible for the module program for the Android / iOS platform, packaged into SDK under each hybrid development framework, adaptation and testing, and technical support.",
      },
      skills: {
        item0:
          "1. Familiar with one or more open source frameworks among cocos2d, flutter, React Native, weex, uni-app, and have a preference for module development/modification;",
        item1: "2. Familiar with network, multi-threading, HTTP / HTTPS / Socket;",
        item2: "3. Proficient in the architecture principles of the Android platform, familiar with Java;",
        item3: "4. Experience in iOS development, familiar with Object-C and Swift language.",
      },
    },
    "job-five": {
      title: "Node.js Engineer",
      intro:
        "Participate in the design and implementation of the front-end and back-end infrastructure of the company's external products, and provide stable and reliable services; be responsible for the design and implementation of the front-end and back-end...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1、Participate in the design and implementation of the front-end and back-end infrastructure of the company's external products, and provide stable and reliable services;",
        item1:
          "2、Responsible for the design and implementation of the front-end and back-end architecture of the internal platform;",
        item2:
          "3、Responsible for technical research and innovative technology reference, and solve the problems of high performance, high concurrency and high reliability in the product development process;",
        item3:
          "4、Responsible for the research and development of the company's cloud service products and developer platform;",
        item4:
          "5、Investigate the company's R&D system and process, and provide platform design and technical solutions for the corresponding underlying services;",
        item5:
          "6、Implement the design plan as a specific platform function, continue to track the results, and continuously optimize the user experience;",
        item6:
          "7、Participate in the design of platform data structure and system architecture, and implement some services in the platform through Node.js;",
        item7:
          "8、Responsible for the architecture design and implementation of the project delivered by the company's customers;",
      },
      skills: {
        item0: "1、 More than 3 years of Internet development experience, in-depth understanding of Unix/Linux;",
        item1:
          "2、 Excellent coding ability, proficient in Node.js, familiar with commonly used algorithms, familiar with open source framework, and strong problem-solving ability;",
        item2:
          "3、 Familiar with the front-end framework React/VUE, familiar with front-end engineering and component development mode;",
        item3: "4、 Rich experience in performance optimization of back-end programs;",
        item4: "5、 Master the principles and applications of storage systems such as Redis, MongoDB, and MySQL;",
        item5:
          "6、 Have a certain understanding of distributed computing and distributed storage architecture design concepts and motivations;",
        item6: "7、 Have a deep understanding of the HTTP protocol, familiar with network protocols such as TCP/IP;",
        item7:
          "8、 Bonus points: Have experience in Python, Go, and PHP development; participate in or own open source projects, and have contributed code to the open source community; have experience in the design and development of large-scale back-end services.",
      },
    },
    "job-six": {
      title: "Product manager",
      intro:
        "Responsible for product design, including product architecture and platform system construction, and can innovate product models...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1、Responsible for product design, including product architecture and platform system construction, and can innovate product models;",
        item1:
          "2、Study market demand and usage scenarios, and build standardized product solutions through demand research, function design, strategy formulation, and effect enhancement;",
        item2:
          "3、Collect and analyze market and competition information, make product planning, and be able to conduct a comprehensive product evaluation;",
        item3:
          "4、Cooperate with the team to complete product project review, planning, coordination and communication, tracking and promotion, and ensuring product iteration output;",
        item4: "5、Efficiently collaborate with marketing, R&D, and operation teams to achieve goals together;",
        item5: "6、Responsible for product growth function iteration;",
        item6: "7、Responsible for product brand building.",
      },
      skills: {
        item0: "1、 Experience in commercialized products, with a commercialization system from 0 to 1 is preferred;",
        item1:
          "2、 Good technical ability, more than 1 year of software development experience, cloud computing, IAM, IDaaS related work experience is preferred;",
        item2:
          "3、 Familiar with the entire commercialization chain, understand mainstream platform commercialization models and product design methods;",
        item3: "4、 Participated in the product from 0 to 1 stage;",
        item4: "5、 Can be alone;",
        item5:
          "6、 Have good communication and coordination skills, can work well with different team members and bear greater pressure.",
      },
    },
    "job-seven": {
      title: "Localization Planning Manager",
      intro:
        "Understand, investigate and analyze the target market of localized hardware and software and customer needs, research and master the product market environment, and mine, collect and manage market information...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1、Understand, investigate and analyze the target market of localized hardware and software and customer needs, research and master the product market environment, and mine, collect and manage market information;",
        item1:
          "2、Responsible for the company's medium and long-term product line strategy and roadmap planning, and propose medium and long-term plans and opinions;",
        item2:
          "3、Collect and refine market demand for products, plan for domestic equipment and software products; understand product features and advantages.",
      },
      skills: {
        item0:
          "1、 Bachelor degree or above, 3-5 years of industry experience, major in communications, mechanics, electronics, computer and related fields;",
        item1:
          "2、 Those with a background in localization are preferred, and they understand any of cloud computing, operating systems, information security, IDaaS, and AD;",
        item2: "3、 Familiar with AD and single sign-on technology is preferred;",
        item3: "4、 Have excellent document writing ability and proficiently use mainstream office software;",
        item4:
          "5、 Possess good communication and coordination skills, overall coordination skills, team spirit and stress resistance;",
        item5:
          "6、 Familiar with national policies and requirements, and those who have worked in related fields are preferred.",
      },
    },
    "job-eight": {
      title: "UI designer",
      intro: "Responsible for UI of Authing console and related products and part of UE design...",
      experience: "3-5 years / undergraduate",
      description: {
        item0: "1、Responsible for UI of Authing console and related products and part of UE design;",
        item1:
          "2、Participate in some creative and operational design, promote the design and implementation of the plan;",
        item2:
          "3、Follow up product development, check and accept and optimize interaction, vision, and enhance the brand image of the product.",
      },
      skills: {
        item0: "1、 Design experience in B-end products is preferred;",
        item1:
          "2、 Familiar with the design specifications related to webpages and APPs, and be able to express the design plan clearly and completely;",
        item2: "3、 Have a keen insight into Internet products and fashion trends, design creativity and passion;",
        item3: "4、 Have good communication skills and be able to cooperate with products and R&D teams in output;",
        item4: "5、 Familiar with software such as Sketch, PS, AI;",
        item5: "6、 Thoughtful and logical, able to withstand high-intensity work pressure.",
      },
    },
    "job-nine": {
      title: "Technical Support Engineer",
      intro:
        "Responsible for supporting and maintaining customers who have implemented Authing SaaS solutions, and responding to customers' technical issues in a timely manner...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1、Responsible for supporting and maintaining customers who have implemented Authing SaaS solutions, and responding to customers' technical issues in a timely manner;",
        item1:
          "2、Responsible for solving customer problems and being able to establish a good relationship with customers, and achieve the highest customer satisfaction;",
        item2:
          "3、Responsible for the docking of customer needs in the early stage, and give reasonable suggestions from a professional perspective;",
        item3:
          "4、Responsible for solving various problems in the development life cycle and proposing corresponding solutions;",
        item4: "5、Collaborate with other departments of the company.",
      },
      skills: {
        item0: "1、 Understand the basic knowledge of software development and general architecture;",
        item1: "2、 Have knowledge of HTTP, encryption and basic security concepts;",
        item2: "3、 Understand the concepts of authentication and authorization;",
        item3: "4、 Understand at least one authentication protocol: OAuth2, OIDC, SAML, WS-FED, LDAP, Azure AD, etc.;",
        item4: "5、 Proficient in at least one programming language, preferably Node.js, JavaScript;",
        item5: "6、 2 years and above technical support or software development experience;",
        item6: "7、 2-5 years of analysis and management experience in medium and large To B projects;",
        item7:
          "8、 Possess multitasking ability, communication ability, strong collaboration ability and subjective initiative.",
      },
    },
    "job-ten": {
      title: "Identity Solutions Engineer",
      intro:
        "Responsible for training software engineers, software architects and product owners, and provide technical knowledge about Authing...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1、Responsible for training software engineers, software architects and product owners, and provide technical knowledge about Authing;",
        item1:
          "2、Responsible for supporting the development team of the client company and understanding client needs;",
        item2:
          "3、Responsible for being familiar with Authing's product capabilities, basic technologies and protocols, and able to make suggestions for improvement;",
        item3:
          "4、Responsible for understanding industry trends and other competing products in the market through research.",
      },
      skills: {
        item0: "1、 Have certain To B customer docking experience and strong communication skills;",
        item1:
          "2、 Have experience with at least one of the standard network security protocols OAuth, OAuth2, SAML, LDAP;",
        item2:
          "3、 Experience with HTTP, as well as HTML applications and REST services. Including the use of development tools in the browser to explain HTTP;",
        item3: "4、 Traffic and the ability to interact with HTTP services using HTTP client Curl or Postman;",
        item4:
          "5、 Have experience in at least two programming languages, JavaScript and another statically typed language;",
        item5:
          "6、 Have at least two back-end technology stacks, such as Node.js, Java experience, and mainstream front-end technology stacks such as React, Angular experience;",
        item6:
          "7、 Have experience in building complete technology stack applications (front-end SPA or mobile App, back-end REST API, database);",
        item7: "8、 Have the ability to host a complete technology stack application (Heroku, Azure, AWS).",
      },
    },
    "job-11": {
      title: "Senior Solution Architect",
      intro:
        "Responsible for the solution architecture design of the industry, to ensure that the solution architecture has long-term competitiveness and that the architecture can be executed...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Responsible for the solution architecture design of the industry, to ensure that the solution architecture has long-term competitiveness and that the architecture can be executed;",
        item1:
          "2. Go deep into the front line of customers, understand the needs and pain points of customers in the industry, explore the deep-seated needs of customers, propose innovative solutions and ensure that the needs are implemented, so as to help customers succeed;",
        item2:
          "3. Responsible for supporting our entire customer to successfully organize and solve complex technical solutions or customer-related problems;",
        item3:
          "4. Responsible for cooperating with the product department and proposing relevant new function suggestions from the customer's perspective.",
      },
      skills: {
        item0:
          "1. Have more than 5 years of relevant experience in the software industry and more than 3 years of experience in the SaaS industry;",
        item1: "2. Strong leadership ability, able to handle multiple business conflicts according to priority;",
        item2: "3. Working knowledge of identity, authentication and authorization protocols and application security;",
        item3: "4. Experience with Web security best practices and standards;",
        item4:
          "5. Have an in-depth understanding of software development process and software design methods, and have development experience in Node.js, .NET or similar products;",
        item5: "6. Have experience in large-scale technology implementation in a complex solution environment;",
        item6: "7. Experience in designing and developing API and RESTFul services;",
        item7:
          "8. Experience in cloud implementation models and platforms (such as Alibaba Cloud/AWS, Azure and Heroku);",
        item8: "9. Have relevant experience in technical solutions;",
        item9: "10. Strong resistance to pressure;",
        item10:
          "11. Able to establish and maintain strong working relationships with stakeholders at all levels in order to achieve win-win results for customers and Authing;",
        item11: "12. Excellent written and oral communication skills.",
      },
    },
    "job-12": {
      title: "Senior Solution Engineer",
      intro:
        "Responsible for providing product demonstrations to potential customers and understanding customer needs through Q&A sessions...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Responsible for providing product demonstrations to potential customers and understanding customer needs through Q&A sessions;",
        item1:
          "2. Responsible for cooperation with multiple business departments such as software engineering, operations, and products;",
        item2: "3. Responsible for providing Authing solutions for customers;",
        item3: "4. Responsible for effective PoC for potential customers;",
        item4: "5. Maintain in-depth technical understanding of Authing products and basic technologies;",
        item5: "6. Learn about industry trends through self-study, research, and online courses;",
        item6: "7. Actively participate in various activities to make Authing a presenter and participant.",
      },
      skills: {
        item0: "1. Have 5 years or more of pre-sale engineering experience;",
        item1: "2. Have experience working in the process and characteristics of federal and/or SLED accounts;",
        item2: "3. Experience in customer service, consulting or sales support experience is preferred;",
        item3: "4. Have JavaScript experience;",
        item4: "5. Experience in SaaS and cloud platforms (AWS, Alibaba Cloud, etc.);",
        item5: "6. Have at least one back-end technology stack (Node.js, Java, .NET) experience;",
        item6: "7. Experience in popular front-end technology stacks (React, Angular);",
        item7: "8. Have experience in at least one standard network security protocol (OAuth, OAuth2, SAML, LDAP);",
        item8:
          "9. Understand the core security issues in typical applications (password hashing, SSL/TLS, encryption at rest, XSS, XSRF);",
        item9:
          "10. Experience with HTTP, as well as HTML applications and REST services. This includes the ability to use development tools in the browser to interpret HTTP traffic and use an HTTP client (Curl or Postman) to interact with HTTP services;",
        item10: "11. Have time management, project management skills, and multi-department collaboration capabilities;",
        item11: "12. Have strong expression skills and instant speech skills.",
      },
    },
    "job-13": {
      title: "System engineer",
      intro:
        "Responsible for solving customers' emerging problems, providing troubleshooting, classification, diagnosis and solutions...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Responsible for solving customers' emerging problems, providing troubleshooting, classification, diagnosis and solutions;",
        item1:
          "2. Responsible for maintaining and updating the platform infrastructure, deploying and protecting new dedicated private customer environments on the cloud;",
        item2: "3. Responsible for performing application setup, integration, configuration and update;",
        item3: "4. Responsible for expanding and perfecting Authing's operating documents;",
        item4:
          "5. Strong collaboration skills, cooperating with many other technical and service teams in the organization.",
      },
      skills: {
        item0:
          "1. Understand the services and resources of Alibaba Cloud/AWS, such as EC2, EBS, ELB/ALB, VPC, RDS, SNS, S3, Kinesis, Lambda, IAM, etc. in AWS;",
        item1: "2. Familiar with Ubuntu Linux, Nginx, MongoDB, Docker, ElasticSearch, Postgres, etc.;",
        item2:
          "3. Understand at least two or more common protocols below, such as HTTP, TLS / SSL, DNS, SSH, TCP / IP;",
        item3: "4. Be able to use at least one of the following custom deployment tools, such as Terraform / Ansible;",
        item4: "5. Ability to use Git and Github for version control.",
      },
    },
    "job-14": {
      title: "Customer Sales Development Representative",
      intro:
        "Proactively contact potential customers through multiple channels such as telephone, social media, and related exhibitions, and tap potential customer needs...",
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Proactively contact potential customers through multiple channels such as telephone, social media, and related exhibitions, and tap potential customer needs;",
        item1: "2. Analyze customer needs and propose corresponding document information solutions for customer needs;",
        item2:
          "3. According to the different business scenarios of customers, he is responsible for early contact, follow-up, formulation of sales strategy, business negotiation, customer situation maintenance, etc., to promote sales goals.",
      },
      skills: {
        item0: "1. Have good sales and customer service capabilities;",
        item1: "2. Have more than one year of experience as a sales representative in the SaaS industry;",
        item2:
          "3. Cheerful personality, excellent expression and communication skills, able to adapt to irregular business trips;",
        item3:
          "4. Have a high degree of enthusiasm for work, strong ability to resist pressure, good teamwork spirit and creative thinking.",
      },
    },
    "job-15": {
      title: "SME Account Manager",
      intro: "Responsible for providing professional solutions to customers and follow up in real time...",
      experience: "3-5 years / undergraduate",
      description: {
        item0: "1. Responsible for providing professional solutions to customers and follow up in real time;",
        item1:
          "2. Grasp the industry dynamics, and accurately predict monthly and quarterly income by analyzing internal data;",
        item2: "3. Actively explore the market and establish good cooperation with industry customers;",
        item3: "4. Responsible for maintaining customer relationships and promoting long-term cooperation;",
        item4: "5. Manage customers and improve the sales process through CRM.",
      },
      skills: {
        item0: "1. Have more than 1 year of SaaS sales experience, better sales experience;",
        item1: "2. Possess strong communication and negotiation skills;",
        item2: "3. Possess multi-task management ability and organization ability;",
        item3: "4. Proficency in office softwares.",
      },
    },
    "job-16": {
      title: "Large corporate account manager",
      intro:
        "Responsible for formulating and implementing strategic customer sales plans; achieving expected goals by identifying, managing and expanding sales opportunities, and improving the sales system...",
      experience: "3-5 years / undergraduate",
      description: {
        item0: "1. Responsible for formulating and implementing strategic customer sales plans;",
        item1:
          "2. To achieve the expected goals by identifying, managing and expanding sales opportunities, and improve the sales system;",
        item2: "3. Develop and manage sales through our CRM system to accurately forecast monthly and quarterly sales;",
        item3:
          "4. Responsible for exploring the market, developing new channels, and establishing good strategic cooperative relations with partners and suppliers;",
        item4:
          "5. Responsible for managing the internal CRM system and coordinating resources to support customer sales and customer success teams;",
        item5: "6. Responsible for research and analysis of competing products to ensure rapid iteration of Authing;",
        item6:
          "7. Responsible for cooperating with internal market, production and research departments and teams to complete the work of this department on time;",
        item7: "8. Responsible for the development of large customers, if necessary, need to travel.",
      },
      skills: {
        item0: "1. Responsible for the development of large customers, if necessary, need to travel.",
        item1: "2. Have strong communication skills, negotiation skills, and self-management skills;",
        item2: "3. Possess the ability of multi-task management, organization and teamwork;",
        item3: "4. Experience in identity, security or developer docking is preferred;",
        item4: "5. Proficency in office softwares.",
      },
    },
    "job-17": {
      title: "Government Account Manager",
      intro: `As a public sector account manager, you will be responsible for promoting the sales and expansion of the Authing identity management platform among government customers (government/park/health departments, etc.) and enterprise-level customers...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0: "1. Define and execute strategic customer sales plans;",
        item1:
          "2. Achieve and exceed sales targets by identifying, managing and completing expansion and obtaining new sales opportunities to ensure customer retention;",
        item2: "3. Develop and manage sales channels through the CRM system;",
        item3:
          "4. Serve as the main customer contact for all customers and coordinate resources to support pre-sales and post-sales work;",
        item4: "5. Have effective and outstanding communication skills with management, customers and partners;",
        item5: "6. Accept irregular business trips, such as to support sales at the customer's location.",
      },
      skills: {
        item0:
          "1. Have more than 3 years of enterprise software sales experience in government departments/and government clients;",
        item1: "2. Strong business negotiation skills with excellent communication skills and a win-win mentality;",
        item2: "3. Have the ability to work independently and work in a team according to the actual situation;",
        item3: "4. Strong organizational capabilities to manage multiple sales opportunities and customer needs;",
        item4: "5. Working experience in the field of identity security is preferred.",
      },
    },
    "job-18": {
      title: "Technical operations",
      intro: `Responsible for Authing's product promotion and operation, build user operation system, explore and formulate Authing's overall promotion plan...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Responsible for Authing's product promotion and operation, build user operation system, explore and formulate Authing's overall promotion plan;",
        item1:
          "2. Responsible for the operation of Authing community, and continue to train community KOLs and evangelists;",
        item2:
          "3. Work with team members to effectively implement a series of Authing plans, including content operation, user operation, event operation, community operation, etc.",
      },
      skills: {
        item0: "1. More than 2 years of technical community operation or B-end product operation experience;",
        item1:
          "2. Possess strong systematic thinking, cross-team communication and coordination skills; strong execution, strong ability to withstand pressure; good customer success-oriented thinking;",
        item2:
          "3. Quick learning ability, love of technology, like to make friends with engineers, in a relatively short period of time can generate basic knowledge of database products and community members;",
        item3: "4. Excellent English, experience in operating overseas communities is preferred;",
        item4: "5. Experience in operating high-quality technical content is preferred;",
      },
    },
    "job-19": {
      title: "General Ledger Accountant",
      intro: `Carry out daily accounting processing and accounting verification control in accordance with the accounting system, and be responsible for the overall accounting...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0:
          "1. Carry out daily accounting processing and accounting verification control in accordance with the accounting system, and be responsible for the overall accounting;",
        item1: "2. Input tax verification and management, issuance of output tax receipts, and reasonable tax control;",
        item2:
          "3. Supervise tax declarations in a timely manner and check tax-related subjects to ensure that taxes are accurate for the current month;",
        item3:
          "4. Complete monthly settlement related work as required and issue financial statements to ensure their accuracy;",
        item4: "5. Cooperate to complete the annual review, tax review, etc., and other related work;",
      },
      skills: {
        item0: "1. 985/211 Bachelor degree or above, major in finance;",
        item1:
          "2. Experience in general ledger accounting, junior accountant title, intermediate accountant title is preferred;",
        item2: "3. More than 2 years of work experience, working experience in a startup company is preferred;",
        item3:
          "4. Clear thinking, strong learning and communication skills, focus on teamwork, responsible, self-motivated, meticulous and responsible;",
        item4:
          "5. Familiar with the latest corporate accounting standards, solid accounting expertise, proficient in using Excel functions and pivot tables, and performing data statistics and analysis;",
      },
    },
    "job-20": {
      title: "Overseas market operation of SaaS products",
      intro: `Daily update and maintenance of English new media platform and website...`,
      experience: "2-5 years / undergraduate",
      description: {
        item0: "1. Daily update and maintenance of English new media platform and website;",
        item1:
          "2. Analyze and have in-depth insight into industrial Internet, especially SaaS market trend, and provide strategic development direction guidance and suggestions for business leaders;",
        item2:
          "3. Deeply understand the SaaS market of the industry and Europe and America, and assist the SaaS product team to find out the potential opportunities and growth points of overseas markets;",
        item3: "4. Analyze the business data, identify the key problems and put forward the improvement plan;",
      },
      skills: {
        item0: "1. Bachelor degree or above, at least 2 years related working experience;",
        item1:
          "2. Excellent English communication skills, international team work experience or study abroad experience is preferred;",
        item2: "3. Familiar with overseas social media and SaaS market and related industry forum;",
        item3: "4. Work actively, like challenge, can bear certain work pressure;",
      },
    },
    "job-21": {
      title: "Test Engineer",
      intro: `Design test cases according to product requirements and test plans, execute test cases, and skillfully use bug management...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0: "1. Design test cases according to product requirements and test plans, execute test cases, and skillfully use bug management tools to submit and track;",
        item1: "2. Complete product integration test, system test, and comprehensive test of product interface and function;",
        item2: "3. Write relevant test reports according to the test process, and cooperate with R & D personnel for function debugging;",
        item3: "4. As the central interface of business and product R & D, it receives and analyzes business requirements and promotes the improvement of product and R & D;",
        item4: "5. Responsible for introducing and improving new testing methods to improve testing efficiency;",
        item5: "6. Responsible for establishing quality metrics to drive product quality improvement;",
      },
      skills: {
        item0: "1. At least 3 years QA working experience, familiar with Web testing;",
        item1: "2. Familiar with mobile terminal Automation testing framework, automatic use case writing, and able to optimize the framework;",
        item2: "3. Familiar with android/ios platform features, have certain programming ability, familiar with Java language;",
        item3: "4. Familiar with HTTP protocol, restful API and working principle of Internet application;",
        item4: "5. Knowledge of agile development and CI / CD;",
        item5: "6. Good communication and problem solving skills, good execution and driving force;",
      },
    },
    "job-22": {
      title: "Commercial Assistant",
      intro: `Statistics, collation and analysis of department sales data...`,
      experience: "3-5 years / undergraduate",
      description: {
        item0: "1. Statistics, sorting and analysis of department sales data;",
        item1: "2. Follow up the sales progress of the Department to promote the achievement of sales orders;",
        item2: "3. Actively cooperate with sales students to deal with pre-sales or after-sales related work;",
        item3: "4. Arrange and organize department meeting and customer meeting;",
        item4: "5. Other temporary work assigned by leaders;",
      },
      skills: {
        item0: "1. Bachelor degree or above;",
        item1: "2. Sales assistant experience is preferred;",
        item2: "3. Serious and responsible, careful and warm-hearted, good at communication, strong pressure resistance ability;",
        item3: "4. Business trip is acceptable;",
      },
    },
  },
  "job-detail": {
    publishtimer: "Release time",
    "label-description": "Job Description",
    "label-skills": "Job Requirements",
    "label-newjob": "Latest position",
    "button-apply": "Apply now",
    navbar: {
      nav0: "About Authing",
      nav1: "Join us",
    },
  },
};
